import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import classes from "./PayoutMethods.module.css";
import PageLayout from "../../PageLayout/PageLayout";
import {
  SettingsMasterCard,
  Visa,
  Threedots,
  Payment,
  SafePayments,
} from "../../../../../constant/imagePath";
import { Button } from "../../../../../stories/Button/Button";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import PayoutMethodsMobile from "./PayoutMethodsMobile";
import { RemovePayoutMethodModal } from "../../../../../components/Modals/CoachFlow/Settings/RemovePayoutMethod/RemovePayoutMethod";
import PaymentMethodCard from "../../../../../stories/PaymentMethodCard/PaymentMethodCard";
import AddPayoutMethod from "../../../../../components/Modals/CoachFlow/OnBoarding/AddPayoutMethod/AddPayoutMethod";

const PayoutMethodsDesktop = () => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const paymentarray = [
    {
      type: "master",
      title: "Master Card",
      number: "3679",
      description: "This is your default payment method",
      default: true,
      methodType: 'bank'
    },
    {
      type: "visa",
      title: "Visa Card",
      number: "6543",
      description: "",
      methodType: 'bank'
    },
  ];
  return (
    <div className={[classes.PayoutMethodScreen].join(" ")}>
      <Container fluid className={[classes.container, "p-0"].join(" ")}>
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
              }}
            >
              Profile Settings
            </h3>
          </Col>
        </Row>
        <Row className={["g-0"].join(" ")}>
          <Col md={8}>
            <Row className={["g-0", classes.paymentCards].join(" ")}>
              {paymentarray.map((item, i) => {
                return (
                  <Col md={12} key={i}>
                    <PaymentMethodCard
                      data={item}
                      onRemove={() => setIsRemoving(true)}
                    />
                  </Col>
                );
              })}
            </Row>
            <div className={[classes.addpaymentbtn].join(" ")}>
              <Button
                primary={false}
                size="Large"
                customStyle={{ width: "max-content" }}
                onClick={() => setIsAdding(true)}
              >
                Add new payment method
              </Button>
            </div>
          </Col>

          <Col md={4} className={[classes.pl36].join(" ")}>
            <div className={[classes.paylayoutdiv].join(" ")}>
              <img src={SafePayments} />
            </div>
          </Col>
        </Row>
        {/* Below modal is shown when payment cancel on stripe modal  */}
        <RemovePayoutMethodModal show={isRemoving} setShow={setIsRemoving} />
        <AddPayoutMethod show={isAdding} setShow={setIsAdding} />
      </Container>
    </div>
  );
};

const PayoutMethod = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <PayoutMethodsMobile /> : <PayoutMethodsDesktop />;
};

export default PayoutMethod;
